import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useLocalizeMessage, useToastNotification } from 'libs.nucleus';
import { DataReportsContext } from '../../../contexts/data_reports/data_reports.context';
import { DataReportDashboard } from '../../components/report_dashboard/report_dashboard.component';
const ReportDashboardPage = ({ studyId: studyIdProp, rosettaReports, reportsListPath }) => {
    const translate = useLocalizeMessage();
    const navigate = useNavigate();
    const { studyId: paramStudyId, reportId } = useParams();
    const studyId = studyIdProp || paramStudyId;
    const { addNotification } = useToastNotification();
    const [searchParams] = useSearchParams();
    const { selectedTestEnv, setStudyId, triggerCortexLogin, setIsCortexLoginSettled, fetchAuthPolicies, setActiveReportsTab, } = useContext(DataReportsContext);
    const env = searchParams.get('env');
    const fetchAuthPoliciesCalledRef = useRef(null);
    useEffect(() => {
        if (studyId && setStudyId) {
            setStudyId(studyId);
        }
        if (!env) {
            const fallbackPath = reportsListPath || `/studies/${studyId}/data/reports`;
            navigate(fallbackPath, { replace: true });
            addNotification({ title: translate('Please select an environment to view reports'), type: 'error' });
        }
        else {
            setActiveReportsTab(env === 'test' ? 0 : 1);
        }
    }, [studyId, env, navigate, addNotification]);
    useEffect(() => {
        if (studyId && fetchAuthPoliciesCalledRef.current !== studyId) {
            fetchAuthPoliciesCalledRef.current = studyId;
            fetchAuthPolicies(studyId);
        }
    }, [studyId, fetchAuthPolicies]);
    useEffect(() => {
        return () => {
            setIsCortexLoginSettled(false);
        };
    }, []);
    useEffect(() => {
        if (selectedTestEnv.value) {
            triggerCortexLogin();
        }
        else if (env === 'prod') {
            triggerCortexLogin();
        }
    }, [selectedTestEnv.value, env]);
    return (_jsx(DataReportDashboard, { studyId: studyId ?? '', reportId: reportId ?? '', rosettaReports: rosettaReports, reportsListPath: reportsListPath }));
};
export default ReportDashboardPage;
